'use client';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';
import { useMediaQuery } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import IconButton from '@mui/material/IconButton';
import SearchAutocomplete from '@components/shared/SearchAutocomplete';
import { classNames } from '@repo/ui/src/utils/classNames';
import { memo } from 'react';

const NavbarSearch = ({ href, placeholder }) => {
  const { push } = useCurrentUrl();
  const lgAndUp = useMediaQuery((theme) => theme.breakpoints.up('lg'));
  const url = href || 'search';

  const doSearch = (searchTerm) => {
    const href = searchTerm ? `${url}?term=${searchTerm}` : url;
    push(href, href, { locale: false });
  };

  if (lgAndUp) {
    return (
      <SearchAutocomplete
        placeholder={placeholder}
        label={placeholder}
        onSearch={doSearch}
        className={classNames(
          'tw-m-0 tw-min-w-[12rem]',
          '[&_input]:tw-text-white [&_input]:tw-bg-neutral-800 [&_input]:tw-border-none [&_input]:tw-rounded-[20px] [&_input]:tw-py-2 [&_input]:tra-input-text',
          '[&_svg]:tw-size-4 [&_svg]:tw-mr-2 [&_svg]:-tw-mt-1 [&_li]:tw-py-1',
        )}
      />
    );
  }

  return (
    <IconButton
      aria-label="Search"
      href={url}
      size="large"
      sx={{ color: 'white', '&:hover': { color: 'white' } }}
    >
      <SearchIcon />
    </IconButton>
  );
};

export default memo(NavbarSearch);
